import { useTranslation } from 'react-i18next'

import Table, { type Column } from '@/components/Table/Table'

import styles from './GradesTable.module.scss'
import { type StudentGrade } from '../../types/grades'

type GradesTableProps = {
  isLoading?: boolean
  noHoverEffect?: boolean
  withBorders?: boolean
  students: StudentGrade[]
  columns: Column<StudentGrade>[]
}

const GradesTable = (props: GradesTableProps) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.container}>
      <Table
        withBorders={props.withBorders}
        noRowHoverEffect={props.noHoverEffect}
        isLoading={props.isLoading}
        id="grades-table"
        data={props.students}
        columns={props.columns}
        rowClassName={styles.row}
        showTopBar={false}
        caption={t('header.grades')}
      />
    </div>
  )
}

export default GradesTable
